import React from 'react';
import BackIcon from '../../../assets/images/icon-back-button.svg';

export default function ButtonBack({className, text, disabled, ...other}) {
	return <button className={` button button--back ${className ? className : ''}`} disabled={disabled} {...other}>
		<img src={BackIcon} alt="back" className="margin__right--xs"/>
		{text}
	</button>
}
